import type { GHLUserData, GHLUserTokenResponse } from '~entities/users/hooks';

// Re-export GHL types for convenience
export type { GHLUserData, GHLUserTokenResponse };

export interface UserRole {
  id?: string;
  name: string;
  value: number;
}

export enum UserRoles {
  SUPER_ADMIN = 'SUPER_ADMIN',
  ADMIN = 'ADMIN',
  STAFF = 'STAFF'
};

export enum UserRoleLabels {
  SUPER_ADMIN = 'Super Admin',
  ADMIN = 'Admin',
  STAFF = 'Staff'
};

export interface User {
  id?: string;
  isFirstLogin?: boolean;
  noPassword?: boolean;
  isAgencyAdmin?: boolean;
  selectedSession?: {
    id: string;
    name: string;
  } | null;
  firstName: string;
  lastName: string;
  email: string;
}
export interface UserWithRole extends User {
  role: UserRole;
};

export interface LoginResponse {
  token: string;
  user: UserWithRole;
};
